import { _config } from '~/utilities/envConfig';
import log from '~/utilities/log';

export type Topic =
  | 'adc-webview:signin'
  | 'adc-webview:navigation'
  | 'adc-webview:update-account'
  | 'adc-webview:update-password'
  | 'adc-webview:update-email'
  | 'adc-webview:update-phone'
  | 'adc-webview:consents'
  | 'adc-webview:create-account'
  | 'adc-webview:navigate-back-app'
  | 'adc-webview:verify-account'
  | 'adc-webview:setup-password'
  | 'adc-webview:forgot-password'
  | 'adc-webview:verify-phone'
  | 'adc-webview:request-otp'
  | 'adc-webview:connections';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const notifyApp = <T>(topic: Topic, data?: T): void => {
  const message = JSON.stringify({ topic, data });

  if (_config.environment === 'local') {
    log.debug(`ReactNativeWebView: postMessage: "${topic}"`, message);
  }

  window.ReactNativeWebView?.postMessage(message);
};
